import { render, staticRenderFns } from "./UISelect.vue?vue&type=template&id=b37612c0&scoped=true&"
import script from "./UISelect.vue?vue&type=script&lang=ts&"
export * from "./UISelect.vue?vue&type=script&lang=ts&"
import style0 from "./UISelect.vue?vue&type=style&index=0&id=b37612c0&scoped=true&lang=postcss&"
import style1 from "./UISelect.vue?vue&type=style&index=1&module=true&lang=postcss&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../vue-loader-virtual-c5444c0a66/0/cache/vue-loader-npm-15.9.1-90a0e5830b-a9a3ffbe3c.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b37612c0",
  null
  
)

export default component.exports